<script lang="ts">
  export let widgetId: string;
</script>

<section>
  <div
    class="OUTBRAIN"
    data-ob-contentUrl="https://mysites.glance.com/"
    data-widget-id={widgetId}
    data-ob-installation-key="GLANC1BM276P1PMEGNJM37PPD"
    data-external-id="tfportal_l2_bottom"
    data-external-secondary-id="tracfone"
  />
</section>
